<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      vehiculos: undefined,
      shipvias: {},
      almacenes: {},
      user: undefined,
    };
  }
};
</script>

<style>
#app {
  overscroll-behavior-y: contain;
  text-align: center;
}
.redes {
  margin: 0rem 1rem 0rem 1rem;
  font-size: 2rem;
}

a {
  color: #3660aa;
  font-weight: 500;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
